<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div>
      <div class="uk-flex uk-flex-between uk-flex-middle">
        <div>
          <h1 class="uk-h4 uk-margin-remove">
            <span data-uk-icon="icon: cart; ratio:1.2"></span>
            Bestelldetails
          </h1>
        </div>
        <div>
          <a @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
            <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
            Zurück
          </a>
        </div>
      </div>
    </div>
    <div>
      <div class="uk-grid" v-if="sale">
        <div class="uk-width-expand@m">
          <div class="uk-card uk-card-default uk-card-small uk-border-rounded">
            <div class="uk-card-body uk-padding-remove">
              <div data-uk-grid class="uk-grid">
                <div class="uk-flex-1">
                  <div class="uk-padding-small">
                    <span class="uk-text-medium uk-text-muted">Händler:</span><br />
                    {{ sale.details.company }}<br />
                    {{ sale.details.street }}<br />
                    {{ sale.details.zipcode }} {{ sale.details.city }}<br />
                    Deutschland
                  </div>
                </div>
                <div class="uk-width-2-5@s">
                  <div class="uk-padding-small">
                    <div data-uk-grid class="uk-child-width-1-2@xl uk-margin-medium-bottom uk-grid">
                      <div>
                        <span class="uk-text-medium uk-text-muted">Bestellnummer:</span>
                        <p class="uk-margin-bottom-remove uk-margin-remove">
                          <span class="sc-text-semibold">{{ sale.number }}</span>
                        </p>
                      </div>
                      <div>
                        <span class="uk-text-medium uk-text-muted">Datum:</span>
                        <p class="uk-margin-bottom-remove uk-margin-remove">{{ sale.date }}</p>
                      </div>
                    </div>
                    <span class="uk-text-medium uk-text-muted">Gesamtbetrag:</span>
                    <p class="uk-margin-remove uk-text-xlarge sc-text-semibold md-color-red-800">
                      {{ sale.amount | euro }}
                    </p>
                  </div>
                </div>
                <div class="uk-width-1-1">
                  <div class="uk-overflow-auto">
                    <div class="uk-margin-bottom">
                      <table class="uk-table uk-table-small uk-table-divider uk-table-middle">
                        <thead>
                          <tr>
                            <th>Fahrzeug</th>
                            <th class="uk-table-shrink uk-text-nowrap uk-text-center">
                              Preis Netto
                            </th>
                            <th class="uk-table-shrink uk-text-nowrap uk-text-center">
                              Preis Brutto
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="vehicle in sale.items" :key="vehicle.id">
                            <td class="uk-text-nowrap">
                              <p class="uk-margin-remove sc-text-semibold">
                                {{ vehicle.make }} {{ vehicle.model }} {{ vehicle.edition }}<br />
                                <span class="uk-text-small">Nr.: {{ vehicle.carId }}</span>
                              </p>
                            </td>
                            <td class="uk-text-right">{{ vehicle.price }}</td>
                            <td class="uk-text-right">{{ vehicle.priceGross }}</td>
                          </tr>
                          <tr style="padding: 4px 12px;">
                            <td style="padding: 4px 12px;" class="uk-text-right" colspan="2">
                              Summe:
                            </td>
                            <td style="padding: 4px 12px;" class="uk-text-right">
                              {{ sale.amount | euro }}
                            </td>
                          </tr>
                          <tr class="remove-border">
                            <td style="padding: 4px 12px;" class="uk-text-right uk-text-small" colspan="2">
                              MwSt.:
                            </td>
                            <td style="padding: 4px 12px;" class="uk-text-right">
                              {{ tax | euro }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="uk-width-1-3@m uk-width-1-1">
          <div class="uk-card uk-card-default uk-card-small uk-border-rounded">
            <div class="uk-card-body">
              <form class="uk-form-stacked">
                <div class="uk-margin">
                  <label class="uk-form-label">Status</label>
                  <v-select
                    :options="statuses"
                    v-model="sale.status_name"
                    :reduce="status => status.name"
                    :clearable="false"
                  >
                  </v-select>
                </div>
                <div class="uk-margin">
                  <label class="uk-form-label">Bezahlt am</label> 
                  <div class="uk-flex uk-flex-middle">
                    <v-date-picker
                      :input-props="{ class: 'uk-input' }"
                      :theme="{
                        datePickerInputDrag: { light: 'uk-input' }
                      }"
                      v-model="paymentDate"
                      :attributes="datepickerAttr"
                      title-position="left" 
                      :popover="{ visibility: 'click' }"
                    />
                    <a
                      v-if="paymentDate"
                      href="#"
                      @click.prevent="paymentDate = null"
                      class="uk-margin-small-left uk-link-reset uk-text-muted"
                      data-uk-tooltip="Datum leeren"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="20">
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
                <div class="uk-margin">
                  <label class="uk-form-label">Verkäufer</label>
                  <v-select
                    :options="users"
                    v-model="sale.seller"
                    label="name"
                    :reduce="user => user.name"
                    :clearable="true"
                  >
                  </v-select>
                </div>
                <div class="uk-margin">
                  <button class="uk-button uk-button-default uk-width-1-1" @click.prevent="downloadPdf">
                    Bestellschein drucken
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div class="uk-margin-top uk-flex uk-flex-right uk-flex-middle">
            <div class="uk-button-group">
              <button class="uk-button uk-button-primary" @click.prevent="store" :disabled="submitting">
                Speichern
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SaleService from '@/services/sale.service'
import UserService from '@/services/user.service'
import axios from 'axios'
import Configuration from '@/configuration'
const baseURL = Configuration.value('apiFrontend')
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import moment from 'moment'
export default {
  data() {
    return {
      sale: null,
      submitting: false,
      loading: true,
      users: [],
      statuses: [
        {
          name: 'pending',
          label: 'Eingegangen'
        },
        {
          name: 'completed',
          label: 'Abgeschlossen'
        }
      ],
      datepickerAttr: [
        {
          key: 'today',
          dot: true,
          dates: new Date()
        }
      ]
    }
  },
  components: {},
  mounted() {
    this.getSale()
    this.getUsers()
  },
  computed: {
    tax() {
      return (parseFloat(this.sale.amount) - parseFloat(this.sale.amount) / 1.19).toFixed(0)
    },
    paymentDate: {
      get() {
        return this.sale.paymentDate ? new Date(this.sale.paymentDate) : null
      },
      set(value) {
        this.sale.paymentDate = value ? moment(value).format('YYYY-MM-DD') : null
      }
    }
  },
  methods: {
    async store() {
      this.submitting = true
      await SaleService.update(this.$route.params.id, { 
        status: this.sale.status_name,
        paymentDate: this.sale.paymentDate,
        seller: this.sale.seller
      })
      this.getSale()
      iziToast.success({
        title: 'OK',
        message: 'Status gespeichert!',
        timeout: 3000,
        position: 'topCenter'
      })
      this.submitting = false
    },
    async getSale() {
      const sale = await SaleService.getById(this.$route.params.id)
      this.sale = sale.data
      this.loading = false
    },
    async getUsers() {
      const users = await UserService.getList()
      this.users = users.data
    },
    downloadPdf() {
      axios({
        url: `${baseURL}/sale/print/${this.sale.id}`,
        method: 'GET',
        responseType: 'blob' // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `Bestellschein-${this.sale.number}.pdf`)
        document.body.appendChild(link)
        link.click()
      })
    }
  }
}
</script>
<style lang="scss">
.remove-border {
  border: none !important;
}
</style>
